// React
import React from 'react';
import { Col, Card } from 'reactstrap';
import { Link } from 'react-router-dom';

export const CardAssociates = ({ item, setCustomerSelected, toggle }) => {
  return (
    <Col>
      <Card className="card-body card-animate">
        <div className="d-flex mb-4 align-items-center">
          <div className="flex-grow-1 ms-2">
            <h5 className="card-title mb-1">{item.name}</h5>
            <p className="text-muted mb-0">{item.cpf}</p>
          </div>
        </div>
        <h6 className="mb-1">{item.city}</h6>
        <p className="card-text text-muted">{item.phone}</p>
        <Link
          to="#"
          onClick={() => {
            setCustomerSelected(item);
            toggle();
          }}
          className="btn btn-primary btn-sm"
        >
          Ver propostas
        </Link>
      </Card>
    </Col>
  );
};
